import { useContext } from 'react';

import { PracticeReseveContext } from '../../PracticeReseveContext';

import { PRACTICE_RESERVE_MODE, PracticeReserveMode } from '../../../../../models/practice/reserve/mode/PracticeReserveMode';


// 予約フォームのモード切り替えタブ（講師から選ぶ／日時から選ぶ）
function PracticeReserveModeTab() {

  const {
    isLoading,
    reserveMode, changeReserveMode,
  } = useContext(PracticeReseveContext);

  const tabs: { mode: PracticeReserveMode, label: string, icon: string }[] = [
    { mode: PRACTICE_RESERVE_MODE.INST,     label: '講師から選ぶ', icon: 'fas fa-user' },
    { mode: PRACTICE_RESERVE_MODE.DATETIME, label: '日時から選ぶ', icon: 'far fa-calendar-alt' },
  ];


  // モード変更
  const handleMode = (mode: PracticeReserveMode): void => {
    if(!isLoading && mode !== reserveMode) {
      changeReserveMode(mode);
    }
  }


  return (
    <div style={{ display: 'flex', gap: '4px', marginBottom: '5px', borderBottom: 'solid 2px #516ab6' }}>
      {tabs.map((tab) => {
        const isActive = tab.mode === reserveMode;
        return (
          // form の中にあるので type="button"（押しても送信しない）
          <button
            key={tab.mode}
            type="button"
            className="bold"
            onClick={() => handleMode(tab.mode)}
            style={{
              flex: 1,
              padding: '10px 0',
              border: 'solid 1px #516ab6',
              borderBottom: 'none',
              borderRadius: '6px 6px 0 0',
              backgroundColor: isActive ? '#516ab6' : '#fff',
              color: isActive ? '#fff' : '#516ab6',
              cursor: isActive ? 'default' : 'pointer',
            }}
          >
            <i className={tab.icon} style={{ marginRight: '6px' }}></i>
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

export default PracticeReserveModeTab;
